// extracted by mini-css-extract-plugin
export default {"wrapper":"LogoutPage_wrapper__3j-QS"};